import { z } from "zod";

import { InsuranceEligibility } from "../insurances";
import { PATIENT_STATUS } from "./constants";
import { patientScreeningSchema } from "./schemas";

export type PatientStatus =
  (typeof PATIENT_STATUS)[keyof typeof PATIENT_STATUS];

export type PatientScreeningFormSchema = z.infer<typeof patientScreeningSchema>;

export type ScreeningFormSchema = PatientScreeningFormSchema;

export type PatientState = {
  id: number;
  name: string;
  isEligible: boolean;
  timezone: string;
};

export type InsuranceType = {
  id: number;
  name: string;
  eligibility: InsuranceEligibility;
  ehr_id?: number;
};

export type AnswersBase = {
  insuranceNotListed: boolean | null;
  insuranceFreeText: string | null;
};

export type NewPatientAnswers = AnswersBase;

export type ReturningPatientAnswers = AnswersBase;

export type PublicAnswers = NewPatientAnswers;

export type NewPatientScreeningPayload = {
  patientType: "new";
  state: PatientState;
  insurance: InsuranceType | null;
  email: string;
  answers: NewPatientAnswers;
};

export type UserCoachScreeningData = {
  tellUsMore: string | null;
};

export type UserCoachScreeningPayload = UserCoachScreeningData & {
  stateId: number;
};

export type AuthenticatedScreeningPayload = {
  patientType: PatientStatus | null;
  state: PatientState;
  insurance: InsuranceType | null;
  email: string;
  answers: ReturningPatientAnswers;
};

export type PublicScreeningPayload = {
  state: PatientState | null;
  insurance: InsuranceType | null;
  email: string;
  answers: PublicAnswers;
  joinWaitlist?: boolean;
};

export type ScreeningApiPayload =
  | NewPatientScreeningPayload
  | AuthenticatedScreeningPayload
  | PublicScreeningPayload;

export const CoachVisitStateSchema = z.object({
  state: z.any().nullable(),
});

export type StateFormSchema = z.infer<typeof CoachVisitStateSchema>;
